import React from 'react';
import { useOutletContext } from 'react-router-dom';
import { NetworkDetailTabs } from '../components/network/NetworkDetailTabs';

export const WhiteLabelNetworkPage = () => {
  const { network } = useOutletContext();
  
  return (
    <div className="fade-in">
      <NetworkDetailTabs network={network} />
    </div>
  );
};
